import { Progress } from "antd";

const ProgressBar = ({
  label,
  labelClassName = "fs12px",
  strokeWidth = 13,
  strokeColor = "#1bbb6b",
  showInfo = false,
  percent = 1,
  trailColor = "#E3E3E3",
  width,
  type = "line",
  size,
}) => {
  return (
    <>
      <div className="d-flex flex-column gap-1">
        {label && <label className={`${labelClassName}`}>{label}</label>}
        <Progress
          type={type}
          percent={percent}
          strokeColor={strokeColor}
          strokeWidth={strokeWidth}
          showInfo={showInfo}
          size={size}
          trailColor={trailColor}
          style={{ width: width }}
        />
      </div>
    </>
  );
};

export default ProgressBar;
